import Typography from "antd/es/typography";
import { Card, List, Space, Tag } from "antd";
import { SettingOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const CollectionCard = (props) => {
  const navigate = useNavigate();
  const { collection, type, onClickAdd } = props;

  const description = () => {
    return (
      <Space direction="vertical" wrap>
        <Tag
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            navigator.clipboard.writeText(collection.uid);
          }}
        >
          ID {collection.uid}
        </Tag>
        <Text>{collection.name}</Text>
        <Space size={"small"} direction="vertical">
          <Text type="secondary">{collection.PublishingHouseName}</Text>
        </Space>
        <Text type={collection.statut === "unavailable" ? "danger" : "success"}>
          {collection.statut}
        </Text>
      </Space>
    );
  };

  const getActions = () => {
    switch (type) {
      case "add":
        return [
          <PlusOutlined
            onClick={() => {
              if (onClickAdd) onClickAdd(collection);
            }}
            key="add"
          />,
        ];
      default:
        return [
          <EditOutlined
            onClick={() => {
              navigate(`/collection/details/${collection.uid}`);
            }}
            key="edit"
          />,
          <SettingOutlined
            onClick={() => {
              navigate(`/collection/${collection.uid}`, {
                state: { collection },
              });
            }}
            key="setting"
          />,
        ];
    }
  };

  return (
    <List.Item>
      <Card
        cover={
          <img
            alt="example"
            src={
              collection.imgHeader
                ? `https://newbrand.s3.eu-west-3.amazonaws.com/collections/${collection.uid}/headers/${collection.imgHeader}`
                : null
            }
          />
        }
        actions={getActions()}
      >
        <Meta title={collection.name} description={description(collection)} />
      </Card>
    </List.Item>
  );
};

export default CollectionCard;
